import React, { useRef, useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { PopupOverlayContainer, PopupWrapper } from './Popup.style';

interface FilesPopupWrapperPropsTypes {
    children: JSX.Element;
    handleHidePopup: () => void;
    height?: number;
    id?: string;
    isTransparent?: boolean;
    width?: number;
}

export const Popup = observer(({ children, id, width, height, isTransparent, handleHidePopup }: FilesPopupWrapperPropsTypes) => {
    const wrapperRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent): void => {
            const current = wrapperRef.current;
            if (current !== null && current.contains(event.target as Node) === false) {
                handleHidePopup();
            }
        };

        document.addEventListener('mousedown', handleClickOutside);

        return (): void => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [wrapperRef]);

    return (
        <PopupOverlayContainer isTransparent={isTransparent} id={id}>
            <PopupWrapper isTransparent={isTransparent} ref={wrapperRef} width={width} height={height} data-test='popup-wrapper'>
                {children}
            </PopupWrapper>
        </PopupOverlayContainer>
    );
});
